<template>
  <div class="dict-mobile-container">
    <!-- 操作栏 -->
    <div class="operation-bar">
      <el-button type="primary" size="large" @click="handleAdd" class="add-btn">
        <i class="el-icon-plus"></i> 新增字典
      </el-button>
    </div>

    <!-- 移动端卡片列表 -->
    <div class="card-list" v-loading="loading">
      <div 
        v-for="item in dictList" 
        :key="item.id" 
        class="dict-card"
      >
        <div class="card-header">
          <div class="dict-key">{{ getDictKeyLabel(item.dict_key) }}</div>
          <div class="dict-code">{{ item.dict_code }}</div>
        </div>
        <div class="card-content">
          <div class="dict-value">{{ item.dict_value }}</div>
          <div class="note" v-if="item.note">{{ item.note }}</div>
        </div>
        <div class="card-actions">
          <el-button 
            size="mini" 
            type="primary" 
            @click="handleEdit(item)"
            class="action-btn"
          >
            编辑
          </el-button>
          <el-button 
            size="mini" 
            type="danger" 
            @click="handleDelete(item)"
            class="action-btn"
          >
            删除
          </el-button>
        </div>
      </div>
      
      <!-- 空状态 -->
      <div v-if="dictList.length === 0 && !loading" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无字典数据</p>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      append-to-body
      custom-class="mobile-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :lock-scroll="false"
    >
      <el-form :model="dictForm" :rules="rules" ref="dictForm" label-width="80px">
        <el-form-item label="字典键" prop="dict_key">
          <el-select v-model="dictForm.dict_key" placeholder="请选择字典键" style="width: 100%" ref="dictKeySelect">
            <el-option label="赛事类型" value="game_type"></el-option>
            <el-option label="赛事级别" value="game_level"></el-option>
            <el-option label="赛事规模" value="game_scale"></el-option>
            <el-option label="赛事机构" value="game_org"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典值" prop="dict_value">
          <el-input v-model="dictForm.dict_value" placeholder="请输入字典值"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="dictForm.note" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="large">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="large">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { isMobile } from '@/utils/device'

export default {
  name: 'DictMobile',
  data() {
    return {
      loading: false,
      dictList: [],
      dialogVisible: false,
      dialogTitle: '',
      dictForm: {
        id: undefined,
        dict_key: '',
        dict_value: '',
        note: ''
      },
      rules: {
        dict_key: [
          { required: true, message: '请选择字典键', trigger: 'change' }
        ],
        dict_value: [
          { required: true, message: '请输入字典值', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // 获取字典键的显示标签
    getDictKeyLabel(dictKey) {
      const keyMap = {
        'game_type': '赛事类型',
        'game_level': '赛事级别',
        'game_scale': '赛事规模',
        'game_org': '赛事机构'
      }
      return keyMap[dictKey] || dictKey
    },
    
    async fetchData() {
      try {
        this.loading = true
        const response = await request({
          url: '/api/dicts',
          method: 'get'
        })
        if (response.code === 200) {
          this.dictList = response.data
        } else {
          this.$message.error(response.message || '获取字典数据失败')
        }
      } catch (error) {
        console.error('获取字典数据失败:', error)
        this.$message.error('获取字典数据失败')
      } finally {
        this.loading = false
      }
    },
    
    handleAdd() {
      this.dialogTitle = '新增字典'
      this.dictForm = {
        id: undefined,
        dict_key: '',
        dict_value: '',
        note: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 强制设置弹窗位置
        this.forceDialogPosition()
        // 自动聚焦到字典键选择框
        setTimeout(() => {
          this.$refs.dictKeySelect && this.$refs.dictKeySelect.focus()
        }, 100)
      })
    },
    
    handleEdit(row) {
      this.dialogTitle = '编辑字典'
      this.dictForm = { ...row }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 强制设置弹窗位置
        this.forceDialogPosition()
        // 自动聚焦到字典键选择框
        setTimeout(() => {
          this.$refs.dictKeySelect && this.$refs.dictKeySelect.focus()
        }, 100)
      })
    },
    
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该字典数据吗？', '提示', {
          type: 'warning',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        })
        const response = await request({
          url: `/api/dicts/${row.id}`,
          method: 'delete'
        })
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.fetchData()
        } else {
          this.$message.error(response.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除字典数据失败:', error)
          this.$message.error('删除失败')
        }
      }
    },
    
    submitForm() {
      this.$refs.dictForm.validate(async (valid) => {
        if (valid) {
          try {
            const isEdit = !!this.dictForm.id
            const response = await request({
              url: isEdit ? `/api/dicts/${this.dictForm.id}` : '/api/dicts',
              method: isEdit ? 'put' : 'post',
              data: this.dictForm
            })
            if (response.code === 200) {
              this.$message.success(isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.fetchData()
            } else {
              this.$message.error(response.message || (isEdit ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error(isEdit ? '更新字典数据失败:' : '添加字典数据失败:', error)
            this.$message.error(isEdit ? '更新失败' : '添加失败')
          }
        }
      })
    },
    
    // 强制设置弹窗位置
    forceDialogPosition() {
      this.$nextTick(() => {
        setTimeout(() => {
          const dialog = document.querySelector('.mobile-dialog .el-dialog')
          const wrapper = document.querySelector('.mobile-dialog .el-dialog__wrapper')
          if (dialog) {
            dialog.style.margin = '10vh auto'
            dialog.style.marginTop = '10vh'
          }
          if (wrapper) {
            wrapper.style.paddingTop = '0'
            wrapper.style.display = 'flex'
            wrapper.style.alignItems = 'flex-start'
            wrapper.style.justifyContent = 'center'
          }
        }, 50)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dict-mobile-container {
  padding: 16px;
  min-height: 100vh;
  background-color: #f5f7fa;

  .operation-bar {
    margin-bottom: 20px;
    text-align: center;
    
    .add-btn {
      width: 100%;
      height: 48px;
      font-size: 16px;
      border-radius: 8px;
    }
  }

  .card-list {
    .dict-card {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid #e4e7ed;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;

        .dict-key {
          font-size: 14px;
          color: #606266;
          background: #f0f9ff;
          padding: 4px 8px;
          border-radius: 4px;
        }

        .dict-code {
          font-size: 12px;
          color: #909399;
          font-family: monospace;
        }
      }

      .card-content {
        margin-bottom: 16px;

        .dict-value {
          font-size: 16px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 8px;
          word-break: break-all;
        }

        .note {
          font-size: 14px;
          color: #606266;
          line-height: 1.5;
          word-break: break-all;
        }
      }

      .card-actions {
        display: flex;
        gap: 12px;
        justify-content: flex-end;

        .action-btn {
          flex: 1;
          height: 36px;
        }
      }
    }

    .empty-state {
      text-align: center;
      padding: 60px 20px;
      color: #909399;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
      }

      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }

  // 移动端对话框样式
  .mobile-dialog {
    .el-dialog {
      margin: 10vh auto !important;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

      .el-dialog__header {
        padding: 20px 20px 16px;
        background-color: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
        text-align: center;
      }

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }

      .el-dialog__body {
        padding: 20px;
      }

      .el-dialog__footer {
        padding: 16px 20px 20px;
        border-top: 1px solid #f0f0f0;
        text-align: center;

        .el-button {
          width: 45%;
          height: 44px;
          font-size: 16px;
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 480px) {
  .dict-mobile-container {
    padding: 12px;

    .card-list .dict-card {
      padding: 12px;
      margin-bottom: 12px;

      .card-actions {
        gap: 8px;
        
        .action-btn {
          height: 40px;
        }
      }
    }
  }
}
</style> 